import styled from '@rsos/theme/styled';
import { useChatContext } from '../ChatContext';

const WarningContainer = styled.div`
  margin: 4px 12px 12px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const OutgoingTranslationWarning = () => {
  const {
    isTranslatingOutgoingMessages,
    translationLanguageList,
    translationLanguage,
  } = useChatContext();

  if (!translationLanguage || !isTranslatingOutgoingMessages) {
    return;
  }

  const selectedLanguage = translationLanguageList.find(
    o => o.languageCode === translationLanguage,
  );

  return (
    <WarningContainer>
      This message will be sent in {selectedLanguage?.languageDisplayName}.
    </WarningContainer>
  );
};
